import { EmployeeUser } from "../../types";
import { useFlowPages } from "../../hooks/useFlowPages";

interface EmployeeDetailsProps {
  employee: EmployeeUser;
  isOpen: boolean;
  onClose: () => void;
}

export function EmployeeDetails({ employee, isOpen, onClose }: EmployeeDetailsProps) {
  const FormComponent = useFlowPages({
    page: 'employeeDetails',
    props: {
      employee,
      isOpen,
      onClose,
    }
  });

  return <>{FormComponent}</>;
} 